import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Coffee Focus Privacy Policy</h1>

      <p>
        Coffee Focus respects your privacy and is committed to protecting your
        data. We strive to be transparent about what we collect and how we use
        it.
      </p>

      <hr />

      <h2>Data We Collect</h2>

      <p>
        Coffee Focus does not collect or transmit your focus sessions or notes
        by default. However, if you choose to enable iCloud syncing, your data
        will be stored in your iCloud account and may be linked to your Apple ID
        for syncing across devices.
      </p>

      <p>
        Additionally, Coffee Focus allows you to optionally upload photos of
        your coffee. These photos are considered user content and may also be
        stored in iCloud if syncing is enabled, linking them to your Apple ID.
      </p>

      <hr />

      <h3>1. Purchases</h3>
      <p>
        We collect and link purchase history to the user’s identity (e.g., to
        determine if you are a Pro subscriber). This data is used only to enable
        app functionality, such as unlocking paid features. We do not use
        purchase history for advertising, tracking, or profiling purposes.
      </p>

      <hr />

      <h3>2. App Functionality</h3>
      <p>Data may be used to support core features such as:</p>
      <ul>
        <li>Authenticating Pro users</li>
        <li>
          Syncing focus sessions, tasks, and streaks across devices via iCloud
          (if enabled)
        </li>
        <li>
          Syncing optional coffee photos across devices via iCloud (if enabled)
        </li>
        <li>Preventing fraud</li>
        <li>Improving scalability and minimizing crashes</li>
        <li>Ensuring uptime and performance</li>
        <li>Performing customer support</li>
      </ul>

      <hr />

      <h2>Data Storage</h2>
      <p>
        All of your personal content (focus sessions, tasks, streaks, and
        optional photos) is stored locally on your device by default. If you
        enable iCloud syncing, your content is stored in your iCloud account to
        allow access across your devices. Coffee Focus does not access, share,
        or sell your iCloud data.
      </p>

      <hr />

      <h2>Data Security &amp; Disclaimer</h2>
      <p>
        While we take reasonable steps to keep your data secure, Coffee Focus
        cannot be held liable for any loss of locally stored or iCloud-synced
        data. By using the app, you acknowledge and accept that data loss may
        occur.
      </p>

      <hr />

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy as Coffee Focus evolves. Continued use
        of the app after any updates indicates your acceptance of the revised
        policy.
      </p>

      <p>
        <b>Last updated:</b> January 10, 2026
      </p>
    </div>
  );
};

export default PrivacyPolicy;
